import { EnumOption } from './enum-option';

export const ReminderEntityType = {
  Matter: 0,
  ForeignNational: 1, 
  Company: 2, 
  CompanyContact: 3, 
  Report: 4, 
  WorkflowStep: 5, 
  Task: 6, 
  Questionnaire: 7, 
}

export const ReminderEntityTypeList: EnumOption[] = [
  { value: ReminderEntityType.Matter, label: 'Matter' },
  { value: ReminderEntityType.ForeignNational, label: 'Foreign National' },
  { value: ReminderEntityType.Company, label: 'Company' },
  { value: ReminderEntityType.CompanyContact, label: 'Company Contact' },
  { value: ReminderEntityType.Report, label: 'Report' },
  { value: ReminderEntityType.WorkflowStep, label: 'Workflow Step' },
  { value: ReminderEntityType.Task, label: 'Task' },
  { value: ReminderEntityType.Questionnaire, label: 'Questionnaire' },
];